import { useState } from 'react';
import type { CatalogCard as CatalogCardData } from '../../../game/catalog';

interface CatalogCardProps {
  item: CatalogCardData;
  selected: boolean;
  onSelect: () => void;
}

/** Blog-style select card: cover image, title, tags, description. */
export function CatalogCard({ item, selected, onSelect }: CatalogCardProps) {
  const [imageVisible, setImageVisible] = useState(false);

  return (
    <button
      type="button"
      className={['sandbox-picker-card', selected ? 'sandbox-picker-card--selected' : '']
        .filter(Boolean)
        .join(' ')}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <div className="sandbox-picker-card__media">
        {item.coverUrl ? (
          <img
            className="sandbox-picker-card__img"
            src={item.coverUrl}
            alt=""
            loading="eager"
            decoding="async"
            style={{ opacity: imageVisible ? 1 : 0, transition: 'opacity 0.12s ease' }}
            onLoad={() => setImageVisible(true)}
            ref={(node) => {
              if (node?.complete && node.naturalWidth > 0 && !imageVisible) {
                setImageVisible(true);
              }
            }}
          />
        ) : null}
      </div>
      <div className="sandbox-picker-card__body">
        <div className="sandbox-picker-card__title-row">
          <h3 className="sandbox-picker-card__title">{item.name}</h3>
          {selected ? <span className="sandbox-picker-card__badge">ACTIVE</span> : null}
        </div>
        <p className="sandbox-picker-card__desc">{item.description}</p>
        <div className="sandbox-picker-card__tags">
          {item.tags.map((tag) => (
            <span key={tag} className="sandbox-picker-card__tag">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </button>
  );
}
